import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';

export const DefaultList = styled.ul`
  font-size: ${FONT_SIZES.px14};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: 1.79;
  margin-top: 1em;
  margin-bottom: 1em;
`;

export const List: FC<React.PropsWithChildren<{className?: string}>> = ({
  children,
  className,
}) => {
  return (
    <DefaultList className={className}>
      {React.Children.map(children, (child, i) => {
        if (!child) {
          return null;
        }
        return <li key={i}>{child}</li>;
      })}
    </DefaultList>
  );
};
